// UTKU Denizaltısı - Mock Data
export const submarineImages = {
  hero: 'https://images.unsplash.com/photo-1707622057103-7db661e7a6c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxtaWxpdGFyeSUyMHN1Ym1hcmluZXxlbnwwfHx8fDE3Nzc3Njg4MDl8MA&ixlib=rb-4.1.0&q=85',
  exterior1: 'https://images.unsplash.com/photo-1707622058621-6228998d84bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxtaWxpdGFyeSUyMHN1Ym1hcmluZXxlbnwwfHx8fDE3Nzc3Njg4MDl8MA&ixlib=rb-4.1.0&q=85',
  exterior2: 'https://images.unsplash.com/photo-1775384222998-c3b458424353?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtaWxpdGFyeSUyMHN1Ym1hcmluZXxlbnwwfHx8fDE3Nzc3Njg4MDl8MA&ixlib=rb-4.1.0&q=85',
  tech1: 'https://images.unsplash.com/photo-1760097776530-a6735733c73a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxzdWJtYXJpbmUlMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc3Nzc2ODgwOXww&ixlib=rb-4.1.0&q=85',
  tech2: 'https://images.unsplash.com/photo-1759687448389-757d021525d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxzdWJtYXJpbmUlMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc3Nzc2ODgwOXww&ixlib=rb-4.1.0&q=85',
  interior: 'https://images.unsplash.com/photo-1759712659045-cc187c68f718?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxzdWJtYXJpbmUlMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc3Nzc2ODgwOXww&ixlib=rb-4.1.0&q=85',
  periscope1: 'https://images.unsplash.com/photo-1660751167155-ce4194a1d374?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxzdWJtYXJpbmUlMjBwZXJpc2NvcGV8ZW58MHx8fHwxNzc3NzY4ODE5fDA&ixlib=rb-4.1.0&q=85',
  periscope2: 'https://images.unsplash.com/photo-1625578525732-4078f41c567d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxzdWJtYXJpbmUlMjBwZXJpc2NvcGV8ZW58MHx8fHwxNzc3NzY4ODE5fDA&ixlib=rb-4.1.0&q=85',
  periscope3: 'https://images.unsplash.com/photo-1642459440218-28ffe4e92fc0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxzdWJtYXJpbmUlMjBwZXJpc2NvcGV8ZW58MHx8fHwxNzc3NzY4ODE5fDA&ixlib=rb-4.1.0&q=85',
  periscope4: 'https://images.unsplash.com/photo-1632703880077-938acd1d1f91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxzdWJtYXJpbmUlMjBwZXJpc2NvcGV8ZW58MHx8fHwxNzc3NzY4ODE5fDA&ixlib=rb-4.1.0&q=85',
};

export const heroStats = [
  { label: 'UZUNLUK', value: '68.34', unit: 'm' },
  { label: 'DEPLASMAN', value: '1850', unit: 'TON' },
  { label: 'MAKS. DERİNLİK', value: '400', unit: 'm' },
  { label: 'MÜRETTEBAT', value: '38', unit: 'KİŞİ' },
];

export const technicalSpecs = [
  {
    category: 'BOYUT VE AĞIRLIK',
    items: [
      { name: 'Toplam Uzunluk', value: '68.34 m' },
      { name: 'Çap', value: '6.30 m' },
      { name: 'Yüzey Deplasmanı', value: '1.690 ton' },
      { name: 'Dalış Deplasmanı', value: '1.850 ton' },
    ],
  },
  {
    category: 'PERFORMANS',
    items: [
      { name: 'Yüzey Hızı', value: '12 knot' },
      { name: 'Sualtı Hızı', value: '20 knot' },
      { name: 'Maksimum Derinlik', value: '400 m' },
      { name: 'Menzil', value: '12.000 nm' },
    ],
  },
  {
    category: 'TAHRİK SİSTEMİ',
    items: [
      { name: 'AIP Sistemi', value: 'Yakıt Hücresi' },
      { name: 'Dizel Motor', value: '4 x MTU 16V' },
      { name: 'Elektrik Motoru', value: '3.875 kW' },
      { name: 'Akmaz Dayanıklılık', value: '90 gün' },
    ],
  },
  {
    category: 'SİLAH SİSTEMLERİ',
    items: [
      { name: 'Torpido Tüpleri', value: '8 x 533 mm' },
      { name: 'Ağır Torpido', value: 'DM2A4 SeaHake' },
      { name: 'Füze', value: 'IDAS / Harpoon' },
      { name: 'Toplam Mühimmat', value: '14 birim' },
    ],
  },
];

export const technologies = [
  {
    code: 'T-01',
    title: 'AIP Sistemi',
    subtitle: 'Air Independent Propulsion',
    description: 'Hidrojen yakıt hücreleri ile yüzeye çıkmadan haftalarca dalışta kalabilme yeteneği. Akustik imza minimuma indirgenmiştir.',
    metric: '14 GÜN',
    metricLabel: 'KESİNTİSİZ DALIŞ',
  },
  {
    code: 'T-02',
    title: 'CMS Savaş Yönetimi',
    subtitle: 'Combat Management System',
    description: 'Yerli geliştirilen entegre savaş yönetim sistemi ile eş zamanlı çoklu hedef takibi ve angajman.',
    metric: '256',
    metricLabel: 'EŞ ZAMANLI HEDEF',
  },
  {
    code: 'T-03',
    title: 'Sonar Dizisi',
    subtitle: 'Pasif/Aktif Dinleme',
    description: 'Burun, yan ve kuyruk sonar dizileri ile 360° akustik tarama. Gelişmiş dijital sinyal işleme.',
    metric: '120 KM',
    metricLabel: 'TESPİT MENZİLİ',
  },
  {
    code: 'T-04',
    title: 'Periskop Sistemi',
    subtitle: 'Optronik Mast',
    description: 'Direksiz dijital periskop, termal kamera ve LRF entegrasyonu. Saatlik 4K görüntü kaydı.',
    metric: '4K',
    metricLabel: 'OPTİK ÇÖZÜNÜRLÜK',
  },
  {
    code: 'T-05',
    title: 'Akustik Görevsel',
    subtitle: 'Stealth Coating',
    description: 'Anekoik kaplama ve titreşim emici izolatörler ile son derece düşük akustik imza.',
    metric: '< 90 dB',
    metricLabel: 'AKUSTİK İMZA',
  },
  {
    code: 'T-06',
    title: 'Otomasyon',
    subtitle: 'Integrated Platform',
    description: 'Tüm gemi sistemlerinin tek platformdan yönetimi. Yapay zeka destekli karar verme alt yapısı.',
    metric: '%92',
    metricLabel: 'OTOMASYON ORANI',
  },
];

export const missions = [
  {
    id: 'M-001',
    name: 'Stratejik Caydırıcılık',
    short: 'Strategic Deterrence',
    desc: 'Derin sularda uzun süreli devriye görevleri ile caydırıcılık unsuru oluşturma.',
  },
  {
    id: 'M-002',
    name: 'Denizaltı Savaşı',
    short: 'Anti-Submarine Warfare',
    desc: 'Düşman denizaltılarını tespit, takip ve etkisiz hale getirme operasyonları.',
  },
  {
    id: 'M-003',
    name: 'Yüzey Savaşı',
    short: 'Anti-Surface Warfare',
    desc: 'Yüzey hedeflerine yönelik torpido ve füze ile angajman kabiliyeti.',
  },
  {
    id: 'M-004',
    name: 'İstihbarat & Gözetleme',
    short: 'ISR Operations',
    desc: 'Sahil yakını bölgelerde sessiz istihbarat toplama ve gözetleme.',
  },
  {
    id: 'M-005',
    name: 'Özel Kuvvet Görevleri',
    short: 'Special Operations',
    desc: 'SAT/SAS unsurlarının hedef bölgeye sessiz şekilde intikali ve geri çekilmesi.',
  },
  {
    id: 'M-006',
    name: 'Mayın Harekatı',
    short: 'Mine Operations',
    desc: 'Stratejik su yollarında mayın döşeme ve mayın tespit görevleri.',
  },
];

export const timeline = [
  { year: '2018', title: 'Proje Başlangıcı', desc: 'UTKU sınıfı denizaltı programının resmi olarak başlatılması.' },
  { year: '2020', title: 'Tasarım Onayı', desc: 'Detaylı mühendislik tasarımının tamamlanması ve onayı.' },
  { year: '2022', title: 'İnşa Başlangıcı', desc: 'Basınç teknesinin ilk bölümlerinin kaynağı yapıldı.' },
  { year: '2024', title: 'Denize İnme', desc: 'UTKU’nun resmi törenle denize indirilmesi.' },
  { year: '2026', title: 'Hizmete Giriş', desc: 'Deniz testlerinin tamamlanarak göreve hazır hale gelmesi.' },
];

export const navLinks = [
  { label: 'ANASAYFA', href: '#hero' },
  { label: 'TEKNİK', href: '#specs' },
  { label: 'TEKNOLOJİ', href: '#tech' },
  { label: 'MİSYONLAR', href: '#missions' },
  { label: 'GALERİ', href: '#gallery' },
  { label: 'İLETİŞİM', href: '#contact' },
];
